import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import LoginNavBar from '../../components/loginNavBar/LoginNavBar';
import { loginFunction } from '../../features-slice/user/functions';
import { isAuthenticated } from '../../utils/auth/auth';
import { validateLogin } from '../../utils/validate/validate';
import GoogleLoginButton from './GoogleLogin';
import ModalResetPassword from '../../components/modals/modalResetPassword/ModalResetPassword';
import axios from 'axios';
import Loader from '../../components/loader/Loader';
import './Login.Module.css';
import { fetchUserInfo } from '../../features-slice/user/userSlice';
import { useMediaQuery } from '@react-hook/media-query';
import { Button } from 'react-bootstrap';
import { Box, Typography } from "@mui/material";

function Login() {
  const isMobile = useMediaQuery({ maxWidth: "450px" });
  const idUsuario = localStorage.getItem('Usuario');
  const token = localStorage.getItem('Token');
  const config = { headers: { xtoken: `${token}` } };

  const [image, setImage] = React.useState('');
  const user = useSelector((state) => state.user.userInfo);
  const isSuperAdmin = user.role === 'SUPERADMIN_ROLE';
  const [loader, setLoader] = React.useState(true);
  const [renderKey, setRenderKey] = React.useState(0);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = React.useState({});

  // NUEVO: toggle para mostrar/ocultar el login clásico
  const [showLegacyLogin, setShowLegacyLogin] = React.useState(false);

  const [showConfirmation, setShowConfirmation] = React.useState(false);
  const handleShowConfirmation = () => setShowConfirmation(true);
  const handleCancelResetPassword = () => setShowConfirmation(false);

  const [userInfo, setUserInfo] = React.useState({ dni: '', password: '' });
  const [openEye, setOpenEye] = React.useState(true);
  const toggleEye = () => setOpenEye(!openEye);

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
    setErrors(validateLogin({ ...userInfo, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (errors.password || !userInfo.dni) {
      toast.error('Revisa tus credenciales');
    } else {
      dispatch(loginFunction(userInfo, navigate));
    }
  };

  React.useEffect(() => {
    const cargarImagenes = async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/imagenes?tipo=FONDO_LOGIN`
      );
      setImage(data.imagenes[0]);
      setLoader(false);
    };
    cargarImagenes();
  }, [renderKey]);

  React.useEffect(() => {
    if (isAuthenticated() && !user.role) {
      dispatch(fetchUserInfo(idUsuario));
    }
  }, [user, dispatch, idUsuario]);

  function handleOpenWidget() {
    try {
      const widgetCloudinary = window.cloudinary.createUploadWidget(
        { cloudName: 'dlblszxyo', uploadPreset: 'laBeautiqueria' },
        async (err, result) => {
          if (!err && result && result.event === 'success') {
            const url = result.info.secure_url;
            await axios.put(
              `${process.env.REACT_APP_BACK_URL}/api/imagenes/${image._id}?url=${url}`,
              '',
              config
            );
            setImage({ ...image[0], url });
            setRenderKey((prevKey) => prevKey + 1);
          }
        }
      );
      widgetCloudinary.open();
    } catch (error) {
      toast.error('Problema con la carga de la imagen', error);
    }
  }

  return (
    <div className='fondoLogin' style={{ backgroundImage: `` }}>
      <header>
        <LoginNavBar />
      </header>

      {loader ? (
        <Loader />
      ) : (
        <main className='mainLogin'>
          {isSuperAdmin && (
            <div className='superadminButtonsss'>
              <div className='fondoLoginButton' onClick={() => handleOpenWidget()}>
                <i className='bi bi-pencil'></i> cambiar fondo
              </div>
              <Button className='toHome' onClick={() => navigate('/')}>
                volver a home
              </Button>
            </div>
          )}

          <Toaster position='bottom-left' reverseOrder={false} toastOptions={{ className: 'fondoToast' }} />

          <div className='container containerForm p-5'>
            <h2 style={{fontFamily:"Poppins"}}>Iniciar Sesión</h2>
            <h4 style={{fontFamily:"Poppins"}} className='pb-3'>Elegí cómo querés ingresar</h4>

            {/* Bloque destacado: Google como primera opción */}
            <div className='card p-4 mb-3' style={{ borderRadius: 12 }}>
              <Typography sx={{ fontSize: isMobile ? "14px" : "16px", marginBottom: "10px" }}>
                Recomendado: usá tu cuenta de Google para entrar más rápido.
              </Typography>
              <div style={{ marginTop: isMobile ? "-10px" : "-6px", marginBottom: "10px" }}>
                <GoogleLoginButton />
              </div>

              <div className='d-flex align-items-center my-2'>
                <div className='flex-grow-1'><hr className='m-0' /></div>
                <span style={{ padding: '0 10px', color: '#999' }}>o</span>
                <div className='flex-grow-1'><hr className='m-0' /></div>
              </div>

              {/* Toggle del login clásico */}
              <button
                type='button'
                className='btn btn-link p-0'
                onClick={() => setShowLegacyLogin(v => !v)}
                aria-expanded={showLegacyLogin}
                aria-controls='legacy-login'
              >
                {showLegacyLogin ? 'Ocultar login con DNI y contraseña' : 'Ingresar con DNI y contraseña'}
              </button>
            </div>

            {/* Login clásico (oculto por defecto) */}
            {showLegacyLogin && (
              <div id='legacy-login' className='card p-4' style={{ borderRadius: 12 }}>
                <Box
                  sx={{
                    backgroundColor: "#fafafa",
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    p: 2,
                    mb: 2,
                    fontSize: "13px",
                    fontFamily: "Poppins",
                    color: "#333",
                  }}
                >
                  <p style={{ marginBottom: 8 }}>
                    Si sos clienta de <b>La Beauti</b>, tu contraseña por defecto es:{" "}
                    <code style={{ color: "#c62828", fontWeight: 600 }}>Beauti1234</code>
                  </p>
                  <p
                    onClick={() => {
                      navigator.clipboard.writeText("Beauti1234");
                      toast.success("Contraseña copiada");
                    }}
                    style={{ color: "#1c4634", fontSize: 13, cursor: "pointer", textDecoration: "underline", margin: 0 }}
                  >
                    Copiar contraseña
                  </p>
                </Box>

                <form onSubmit={handleSubmit}>
                  {/* DNI */}
                  <div className='px-1 py-1'>
                    <Typography sx={{ fontSize: isMobile ? "10px" : "12px" }}>
                      DNI
                    </Typography>
                    <input
                      onChange={handleChange}
                      className='form-control form-control-sm shadow inputLogin'
                      name='dni'
                      type='number'
                      placeholder='Ingresá tu DNI'
                    />
                  </div>

                  {/* Password */}
                  <div className='px-1 py-1'>
                    <Typography sx={{ fontSize: isMobile ? "10px" : "12px" }}>
                      Contraseña
                    </Typography>
                    <div className='input-group input-group-sm'>
                      <input
                        autoComplete='off'
                        onChange={handleChange}
                        className='form-control shadow'
                        name='password'
                        type={openEye ? 'password' : 'text'}
                        placeholder='Contraseña'
                      />
                      <div className='input-group-apend'>
                        <span className='input-group-text shadow'>
                          {openEye ? (
                            <abbr title='Mostrar contraseña'>
                              <i onClick={toggleEye} className='bi bi-eye-slash'></i>
                            </abbr>
                          ) : (
                            <abbr title='Ocultar contraseña'>
                              <i onClick={toggleEye} className='bi bi-eye'></i>
                            </abbr>
                          )}
                        </span>
                      </div>
                    </div>
                    {errors.password ? (
                      <p className='pt-1' style={{ color: 'rgba(255, 0, 0, 0.75)', height: '18px', textAlign: 'left', fontSize: 12 }}>
                        {errors.password}
                      </p>
                    ) : (
                      <div style={{ height: 18 }} />
                    )}
                  </div>

                  <div className='d-flex align-items-center justify-content-between mt-3'>
                    <button type='submit' className='btn btn-secondary py-2 px-4'>
                      INGRESAR
                    </button>
                    <p onClick={handleShowConfirmation} className='link forgot m-0' style={{ fontSize: 13 }}>
                      ¿Olvidaste tu contraseña?
                    </p>
                  </div>
                </form>
              </div>
            )}

            {/* Modal reset password */}
            <div className='sectionModalBorrar'>
              <ModalResetPassword
                className='modaaaaal'
                show={showConfirmation}
                title='Recupero de contraseña'
                message='¿Estás seguro que querés recuperar tu contraseña? Vas a recibir un correo con los pasos. Si no tenés correo asociado, escribinos y te ayudamos.'
                onCancel={handleCancelResetPassword}
                stateUser={(userInfo, setUserInfo)}
                handleChange={handleChange}
              />
            </div>

            {/* Registro */}
            <Typography  style={{ fontFamily:"Poppins"}}sx={{fontFamily:"Poppins", fontSize: isMobile ? "11px" : "13px", marginTop: 16 }}>
              ¿No estás registrada?{" "}
              <span
                style={{ fontFamily:"Poppins",color: "#5c5c5c", cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => navigate('/crearCuenta')}
              >
                Creá tu cuenta
              </span>
            </Typography>
          </div>
        </main>
      )}
      ;
    </div>
  );
}

export default Login;
